import qs from 'qs';
import {APP_URL} from "./constants";

/**
 *
 * consumes a phone string and attempts to format it. Can handle partial strings.
 * @param phoneString
 */
export const addPhoneFormatting = (phoneString: string) => {
  const digits = phoneString
    .replace(/\D/g, '')
    .match(/(\d{0,3})(\d{0,3})(\d{0,4})/) as string[];
  const firstFormat = !digits[2] ? digits[1] : `${digits[1]}-${digits[2]}`;
  const secondFormat = digits[3] ? `-${digits[3]}` : '';
  return `${firstFormat}${secondFormat}`;
};

export const removePhoneFormatting = (formattedPhoneString: string): string => {
  return formattedPhoneString.replace(/\D/g, '');
};

const handlePhoneNumberInput = (e: Event) => {
  const target = e.target as HTMLInputElement;
  if (target.value) {
    target.value = addPhoneFormatting(target.value);
  }
};

if (document.querySelectorAll('[data-js="phone"]').length > 0) {
  // eslint-disable-next-line func-names
  window.onload = function () {
    document.querySelectorAll('[data-js="phone"]').forEach((input) => {
      const currentInput = (input as HTMLInputElement).value;
      // eslint-disable-next-line no-param-reassign
      (input as HTMLInputElement).value = addPhoneFormatting(currentInput);
      (input as HTMLInputElement).addEventListener('input', handlePhoneNumberInput, false);
    });
  };
  window.addEventListener('reloaded', () => {
    document.querySelectorAll('[data-js="phone"]').forEach((input) => {
      const currentInput = (input as HTMLInputElement).value;
      // eslint-disable-next-line no-param-reassign
      (input as HTMLInputElement).value = addPhoneFormatting(currentInput);
    });
  });
}

export const createURL = (state) => `?${encodeURIComponent(JSON.stringify(state))}`;

export const searchStateToUrl = (location, searchState) => (searchState ? `${location}/?query=${createURL(searchState)}` : '');

export const urlToSearchState = (location) => {
  try {
    const result: any = qs.parse(
      location.search.slice(1),
    );
    const searchState = JSON.parse(decodeURIComponent(result.query).slice(1));

    return searchState;
  } catch (e) {
    return {};
  }
};

/**
 * Returns comma delineated string from array of strings. Examples:
 *
 * humanImplode(['test']) => 'test'
 *
 * humanImplode(['test1', 'test2']) => 'test1 and test2'
 *
 * humanImplode(['test1', 'test2', 'test3'], 'or') => 'test1, test2, or test3'
 */
export const humanImplode = (array: string[], conjunction: string = 'and'): string => {
  if (array.length === 0) {
    return '';
  }

  if (array.length === 1) {
    return array[0];
  }

  const seperator = array.length === 2 ? ' ' : ', ';
  const last = array.pop();

  const implode = array.join(', ');

  return `${implode + seperator + conjunction} ${last}`;
};

export const capitalize = (word: string): string => word.charAt(0).toUpperCase() + word.slice(1);

export const capitalizeWords = (string: string): string => {
  return string.split(' ').map((word) => capitalize(word)).join(' ');
};

/**
 * Phone number to be used in examples or field placeholders
 */
export const getPhonePlaceholder = (): string => {
  return addPhoneFormatting('5555555555');
};

/**
 * Basic string replacement for use in urls
 */
export const useLocalUrl = (url: string): string => {
  // replace domain, port, and protocol with local
  const localUrl = url ? url.replace(/https?:\/\/[^/]+/, APP_URL as string) : '';

  // replace any query params with empty string
  return localUrl.replace(/\?.*/, '');
};
